"use strict";

exports.__esModule = true;
exports.default = void 0;

var _schema = _interopRequireDefault(require("../conditionId/schema"));

var _schema2 = _interopRequireDefault(require("../conditionConsequenceId/schema"));

var _schema3 = _interopRequireDefault(require("../conditionStateId/schema"));

var _schema4 = _interopRequireDefault(require("../conditionPurposeId/schema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "type": "object",
  "properties": {
    "parentId": {
      "type": "number"
    },
    "documentType": {
      "type": "string",
      "default": "condition"
    },
    "title": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "content": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "media": {
          "type": "array",
          "items": {
            "type": "image"
          }
        },
        "purposeId": _schema4.default,
        "conditionId": _schema.default,
        "conditionDetails": {
          "type": "string"
        },
        "conditionMethod": {
          "type": "string"
        },
        "completedAt": {
          "type": "string",
          "format": "date"
        },
        "buildingParts": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "buildingPartId": {
                "type": "primusBuildingPart"
              },
              "buildingDetails": {
                "type": "string"
              },
              "description": {
                "type": "string"
              },
              "stateId": _schema3.default,
              "consequenceId": _schema2.default,
              "measures": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "details": {
                      "type": "boolean",
                      "default": false,
                      "enum": [true, false],
                      "enumNames": ["Ja", "Nei"]
                    }
                  },
                  "dependencies": {
                    "details": {
                      "oneOf": [{
                        "properties": {
                          "details": {
                            "enum": [true]
                          },
                          "costEstimate": {
                            "type": "string"
                          },
                          "timeEstimate": {
                            "type": "string"
                          }
                        }
                      }]
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};
exports.default = _default;
module.exports = exports.default;